export const FRONTEND_PLAN_PROFILES = {
    DEMO: {
        id: 'DEMO',
        displayName: 'Demo',
        monthlyPrice: 'Free',
        monthlyCredits: '5',
        monthlyScans: '5',
        dashboardCapacity: '5 demo scans',
        dashboardFootnote: 'demo mode',
        registrationSubtitle: '5 demo scans',
    },
    PRO: {
        id: 'PRO',
        displayName: 'Pro',
        monthlyPrice: '$29/mo',
        monthlyCredits: '1,000',
        monthlyScans: '~1,000',
        dashboardCapacity: '1,000 / month',
        dashboardFootnote: 'credit based',
        registrationSubtitle: '1,000 credits/month',
    },
    TEAM: {
        id: 'TEAM',
        displayName: 'Team',
        monthlyPrice: '$99/mo',
        monthlyCredits: '5,000',
        monthlyScans: '~5,000',
        dashboardCapacity: '5,000 / month',
        dashboardFootnote: 'credit based',
        registrationSubtitle: '5,000 credits/month',
    },
    ENTERPRISE: {
        id: 'ENTERPRISE',
        displayName: 'Enterprise',
        monthlyPrice: 'Custom',
        monthlyCredits: 'Unlimited',
        monthlyScans: 'Unlimited',
        dashboardCapacity: 'Unlimited',
        dashboardFootnote: 'flexible enterprise allowance',
        registrationSubtitle: 'Unlimited + custom patterns',
    },
};
export function getFrontendPlanProfile(tier) {
    if (tier === 'DEMO' || tier === 'PRO' || tier === 'TEAM' || tier === 'ENTERPRISE') {
        return FRONTEND_PLAN_PROFILES[tier];
    }
    return FRONTEND_PLAN_PROFILES.PRO;
}
